import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CheckboxFilterControl, FilterGroup } from '@vendasta/va-filter2';
import { prependStatusFiltersSection } from './filters-utils';

enum SalesOrdersTableTab {
  ALL = 0,
  PENDING = 1,
  APPROVED = 2,
  CANCELLATION_REQUESTS = 3,
  ERRORS = 4,
}

@Injectable({ providedIn: 'root' })
export class SalesOrdersTableTabFilterService {
  statusSectionName = this.translateService.instant('FRONTEND.SALES_UI.STATUS');

  constructor(private translateService: TranslateService) {}

  setTabStatusFilters(selectedTab: number, filters: FilterGroup): void {
    filters?.removeSection(this.statusSectionName);
    switch (selectedTab) {
      case SalesOrdersTableTab.ALL:
        prependStatusFiltersSection(filters, this.translateService);
        break;
      case SalesOrdersTableTab.PENDING:
        filters?.prependSection(this.statusSectionName, [
          new CheckboxFilterControl(
            'resubmitted',
            this.translateService.instant('FRONTEND.SALES_UI.RESUBMITTED'),
            false,
            {
              appliedValueMapper: (name) => ({
                name,
                label: this.translateService.instant('FRONTEND.SALES_UI.RESUBMITTED'),
              }),
            },
          ),
          new CheckboxFilterControl('pending', this.translateService.instant('FRONTEND.SALES_UI.PENDING'), false, {
            appliedValueMapper: (name) => ({
              name,
              label: this.translateService.instant('FRONTEND.SALES_UI.PENDING'),
            }),
          }),
          new CheckboxFilterControl(
            'awaiting-customer-approval',
            this.translateService.instant('FRONTEND.SALES_UI.AWAITING_CUSTOMER_APPROVAL'),
            false,
            {
              appliedValueMapper: (name) => ({
                name,
                label: this.translateService.instant('FRONTEND.SALES_UI.AWAITING_CUSTOMER_APPROVAL'),
              }),
            },
          ),
        ]);
        break;
    }
    filters?.patchValue({ ...filters?.value });
  }
}
